<template>
	<app-page>
		<app-heading :title="isNew ? 'New Page' : page.name" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'website-pages' }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Slug"
					v-model="page.slug"
					required
					:disabled="!isNew"
					:errors="errors.slug"
					:hint="`The slug can't be updated once set. `
							+ `This should be the same as the navigation item counterpart`"
				/>
				<input-text
					label="Name"
					v-model="page.name"
					required
					:errors="errors.name"
					hint="A meaningful name will allow to easily recognize the navigation purpose"
				/>
				<input-select
					v-if="isNew && pageTemplates.length > 0"
					label="Use Page Template (Optional)"
					v-model="page.page_template_id"
					:items="pageTemplates"
					clearable
					hint="Select a page template to copy content from"
				/>
				<input-switch
					label="Disallow bots"
					v-model="page.disallow_bots"
					:errors="errors.disallow_bots"
					hint="Hide this page from sitemaps and block it in robots.txt"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			page: {
				slug: '',
				name: '',
				disallow_bots: false,
				page_template_id: null,
			},
			pageTemplates: [],
			website: null,
			errors: {},
		}
	},
	computed: {
		websiteId() {
			return this.$route.params.website
		},
		id() {
			return this.$route.params.page
		},
		isNew() {
			return this.id === 'new'
		},
	},
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			// Fetch website to get template
			this.website = await this.$ravello.request()
				.v(2)
				.to('websites')
				.to(this.websiteId)
				.fields(['template'])
				.get()

			if (this.id !== 'new') {
				this.page = await this.$ravello.request()
					.v(2)
					.to('websites')
					.to(this.websiteId)
					.to('pages')
					.to(this.id)
					.fields(['name', 'slug', 'disallow_bots'])
					.get()
				this.page.disallow_bots = !!this.page.disallow_bots
			} else if (this.website.template) {
				// Fetch available page templates for this template
				const templates = await this.$ravello.graphql('pagetemplates')
					.fields(['_id', 'name'])
					.filter('template', this.website.template)
					.query()
				this.pageTemplates = (templates || []).map(template => ({
					text: template.name,
					value: template._id,
				}))
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data ? err.data.message : err.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	methods: {
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			const request = this.$ravello.request()
				.v(2)
				.to('websites')
				.to(this.websiteId)
				.to('pages')

			const payload = {
				name: this.page.name,
				slug: this.page.slug,
				disallow_bots: this.page.disallow_bots,
			}

			if (this.isNew && this.page.page_template_id) {
				payload.page_template_id = this.page.page_template_id
			}

			try {
				if (this.isNew) {
					await request.create(payload)
				} else {
					await request.to(this.id).update(payload)
				}

				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Page successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'website-pages' })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
